if (!customElements.get('size-guide-tabs')) {
  customElements.define(
    'size-guide-tabs',
    class SizeGuideTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event));
        });
      }

      onKeydown(event) {
        const key = event.key;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;

        event.preventDefault();
        const currentIndex = this.tabs.indexOf(document.activeElement);
        let newIndex = currentIndex;

        if (key === 'ArrowRight') newIndex = (currentIndex + 1) % this.tabs.length;
        if (key === 'ArrowLeft') newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (key === 'Home') newIndex = 0;
        if (key === 'End') newIndex = this.tabs.length - 1;

        const newTab = this.tabs[newIndex];
        newTab.focus();
        this.selectTab(newTab);
      }

      selectTab(selectedTab) {
        this.tabs.forEach((tab) => {
          const isSelected = tab === selectedTab;
          tab.classList.toggle('size-guide__tab--active', isSelected);
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        });

        this.panels.forEach((panel) => {
          const isSelected = panel.id === selectedTab.getAttribute('aria-controls');
          panel.hidden = !isSelected;
        });
      }
    }
  );
}
